<template>
  <div>
    <div class="inputs">
      <n-form-item :label="label">
        <n-dynamic-input
            v-model:value="rawValue"
            preset="pair"
            key-placeholder="Name component key"
            value-placeholder="Severity override"
            :min="0"
            :max="20"

        :on-create="onCreate"
        ></n-dynamic-input>
      </n-form-item>
    </div>
  </div>
</template>

<script>
import { NDynamicInput, NFormItem } from 'naive-ui'

export default {
  name: 'NamingConventionSeverityOverridesField',
  components: {
    NFormItem,
    NDynamicInput
  },
  watch: {
    rawValue() {
        this.syncFieldValue();
    },
    fieldValue: {
      handler: function (newVal) {
        this.$emit('update:modelValue', newVal);
      },
      deep: true
    }
  },
  props: [
    'modelValue',
    'label',
    'property'
  ],
  computed: {
    hasProperty() {
      return this.property != undefined;
    }
  },
  data() {
    return {
        rawValue: [],
        fieldValue: {}
    };
  },
  methods: {
    initializeRawValue() {
        let rawValue = [];
        if (this.modelValue) {
            for (let key in this.modelValue) {
                rawValue.push({ key: key, value: `${this.modelValue[key]}` });
            }
        }
        this.rawValue = rawValue;
    },
    syncFieldValue() {
        let fieldValue = {};
        for (let elem of this.rawValue) {
            if (!elem.key || !elem.value) continue;
            fieldValue[elem.key] = isNaN(parseInt(elem.value)) ? 0 : parseInt(elem.value);
        }
        this.fieldValue = fieldValue;
    }
  },
  mounted() {
    this.initializeRawValue();
    this.syncFieldValue();
  }
}
</script>

<style lang="scss" scoped>
.n-dynamic-input {
display: block;

  .n-dynamic-input-item {
  align-items: center;
  justify-content: center;

    .n-dynamic-input-item__action {
    margin: auto !important;
    }

  }

}

.n-dynamic-input-item {
margin-bottom: 1rem;

  &:first-child {
  
    label {
    display: block;
    }

  }

  > div {
  margin-right: 1rem;
  }

  label {
  font-weight: bold;
  margin-bottom: .5rem;
  display: none;
  }

}

.n-select {
min-width: 190px;
}

.form-item .form-item {

  > .n-form-item-label {
  margin-bottom: 0px;
  }

}
</style>